<template>
  <!-- zz:科室创建订单 + 科室点开订单详情 -->
  <div class="page-container main">
    <el-button @click="backToList" class="back-button"></el-button>
    <el-form size="small" class="form" label-width="120px" :rules="rules" :model="form" ref="form">
      <el-form-item v-for="item in formList" v-if="isItemVisible(item, form)" :label="item.label" :class="item.type"
                    :key="item.prop" :prop="item.prop">
        <template v-if="item.prop === 'doctorName'">
          <el-input :type="item.type || 'text'" v-model="form[item.prop]"></el-input>
          <!-- <el-button type="primary" @click="dialogVisible = true">添加医生</el-button> -->
        </template>
        <el-input v-else-if="item.filter" :readonly="true" :type="item.type || 'text'"
                  :value="item.filter(form)"></el-input>
        <template v-else-if="item.prop==='priceSum'">
          <el-input :readonly="true" :type="item.type || 'text'" :value="form[item.prop]"></el-input>
          <el-button v-if="refundShow" size="small" type="primary" @click="dialogRefund=true">退款</el-button>
        </template>
        <el-input v-else :type="item.type || 'text'" v-model="form[item.prop]" :disabled="item.disabled"></el-input>
        <el-button v-if="item.prop==='patientName' && isAdmin " size="small" type="default" @click="mergeOrder(form.id)">删除订单</el-button>
      </el-form-item>
      <el-form-item label="重建类型" v-model="reconData" required="required">
        <div class="mockData">
          <el-table :data="reconData" ref="mockTable" border :show-header="false" style="width: 80%">
            <el-table-column label="一级" width="150">
              <template slot-scope="scope">
                <el-checkbox
                  v-model="scope.row.check"
                  @change="changeCheck(scope.row.id,scope.row.level)"
                >{{ scope.row.name + '(默认)' }}
                </el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="二级">
              <template slot-scope="scope">
                <el-checkbox
                  v-for="item in scope.row.children"
                  :key="item.id"
                  v-model="item.check"
                  v-if="!item.ext"
                  @change="changeCheck(scope.row.id,item.level)"
                >{{ item.name }}
                </el-checkbox>
                <div style="border-bottom: 1px dashed #ccc"></div>
                <label class="addition">附加项目：</label>
                <el-checkbox
                  v-for="item in scope.row.children"
                  :key="item.id"
                  v-model="item.check"
                  v-if="item.ext"
                  @change="changeCheck(scope.row.id,item.level)"
                >{{ item.name }}
                  <template v-if="item.name ==='模拟肝切除'">
                    <el-input type="textarea" style="width: 350px;" :rows="1"
                              placeholder="请填写模拟切割术式，如保留肝中静脉右半肝切除" v-if="item.showInput" v-model="item.inputText"
                              clearable>
                    </el-input>
                  </template>
                </el-checkbox>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form-item>

      <el-form-item label="文件" class="file-list">
        <FileUploader
          ref="rawUpload"
          title="原始文件"
          pathName="raw"
          @success="onRawFileSuccess"
          @deleted="onRawDelected"
          required="required"
        ></FileUploader>
        <FileUploader
          ref="examUpload"
          :title="examTitle"
          pathName="exam_report"
          @success="onExamFileSuccess"
          @deleted="onExamReportDelected"
          :limit="5"
        ></FileUploader>
      </el-form-item>
      <el-form-item>
        <!--        <el-button type="primary" @click="onSave" v-if="pageType === 'create'">保存</el-button>-->
        <el-button type="primary" @click="onSubmit">一键精诊</el-button>
        <el-button>取消</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="添加医生"
      :visible.sync="dialogVisible"
      width="400px"
    >
      <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="100px" class="addForm">
        <el-form-item label="医生姓名" label-width="100px">
          <el-input v-model="form.name" placeholder="请输入医生姓名" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="医生电话" label-width="100px">
          <el-input v-model="form.mobile" placeholder="请输入医生电话" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">添 加</el-button>
      </span>
    </el-dialog>

    <el-dialog title="退款" :visible.sync="dialogRefund" center width="30%">
      <el-form ref="refundForm" :model="refundForm" label-width="120px">
        <el-form-item prop="verify" label="安全密码">
          <el-input v-model="refundForm.verify" placeholder="请输入安全密码"></el-input>
        </el-form-item>
        <el-form-item prop="verify" label="退款原因">
          <el-select v-model="refundForm.remark">
            <el-option label="测试订单退款" value="测试订单退款"></el-option>
            <el-option label="患者申请退款" value="患者申请退款"></el-option>
            <el-option label="其他原因" value="其他原因"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="verify" label="退款操作人">
          <el-input v-model="refundForm.optName" placeholder="请输入退款操作人"></el-input>
        </el-form-item>
        <el-form-item label="退款金额">
          <el-input :value="form.priceSum" disabled readonly></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRefund = false">取 消</el-button>
        <el-button type="primary" @click="onRefund">退 款</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import * as R from 'ramda';
import tip from '@/utils/tip';
import {isAdmin, isAgent, isCaptain, isDoc, secondTimeStampText} from '@/utils';
import {refund as refundApi, task as taskApi} from '@/api';
import FileUploader from '@/comp/FileUploader';

const formList = [
  {label: '医院', prop: 'hospitalName', required: true, disabled: true},
  {label: '科室', prop: 'departmentName', required: true, disabled: true},
  // {label: '代理商名称', prop: 'agentName', disabled: true},
  // {label: '代理商电话', prop: 'agentMobile', disabled: true},
  {label: '创建医生', prop: 'doctorName', required: true},
  {label: '医生电话', prop: 'doctorPhone', required: false},
  {label: '患者姓名', prop: 'patientName', required: true},
  {label: '患者ID', prop: 'examPatientId', required: false},
  {label: '患者电话', prop: 'patientPhone'},
  {
    label: '患者支付状态',
    prop: 'payStatus',
    disabled: true,
    visible: ({isAdmin, isCaptain}) => {
      return !!(isAdmin || isCaptain);
    },
    filter: ({payStatus}) => {
      if (payStatus === 0) {
        return '未支付';
      }
      if (payStatus === 1) {
        return '已支付';
      }
      if (payStatus === 2) {
        return '已退款';
      }
      return '';
    },
  },
  {
    label: '患者支付时间',
    prop: 'payTime',
    disabled: true,
    visible: ({isAdmin, isCaptain}) => {
      return !!(isAdmin || isCaptain);
    },
    filter: ({payTime}) => {
      return secondTimeStampText(payTime);
    }
  },
  {
    label: '患者支付金额',
    prop: 'priceSum',
    disabled: true,
    visible: ({isAdmin, isCaptain}) => {
      return !!(isAdmin || isCaptain);
    },
  },
  {
    label: '是否开发票',
    prop: 'invoice',
    visible: ({isAdmin, isCaptain}) => {
      return !!(isAdmin || isCaptain);
    },
    filter: ({invoice}) => invoice === 1 ? '是' : '否'
  },
  {
    label: '发票种类',
    prop: 'invoiceTag',
    visible: ({invoice}) => {
      return !!((isAdmin || isCaptain) && invoice === 1);
    },
    filter: ({invoiceTag}) => invoiceTag === 1 ? '电子发票' : (invoiceTag === 2 ? '纸质发票' : '')
  },
  {
    label: '发票类型',
    prop: 'invoiceType',
    visible: ({invoice}) => {
      return !!((isAdmin || isCaptain) && invoice === 1);
    },
    filter: ({invoiceType}) => invoiceType === 1 ? '个人/事业单位' : (invoiceType === 2 ? '公司企业' : '')
  },
  {
    label: '发票抬头',
    prop: 'invoiceTitle',
    visible: ({invoice}) => {
      return !!((isAdmin || isCaptain) && invoice === 1);
    },
  },
  {
    label: '发票税号',
    prop: 'invoiceTaxNum',
    visible: ({invoice}) => {
      return !!((isAdmin || isCaptain) && invoice === 1);
    },
  },
  {
    label: '收票人手机号',
    prop: 'invoicePhone',
    visible: ({invoice}) => {
      return !!((isAdmin || isCaptain) && invoice === 1);
    },
  },
  {
    label: '收票人电子邮箱',
    prop: 'invoiceMail',
    visible: ({invoice}) => {
      return !!((isAdmin || isCaptain) && invoice === 1);
    },
  },
  {
    label: '发票地址',
    prop: 'invoiceAddr',
    visible: ({invoice}) => {
      return !!((isAdmin || isCaptain) && invoice === 1);
    },
  },
  {label: '病情简述及重建重点', type: 'textarea', prop: 'note', required: true},
];

const form = {
  id: '',
  hospitalName: '',
  departmentName: '',
  doctorName: '',
  doctorPhone: '',
  patientName: '',
  examPatientId: '',
  patientPhone: '',
  note: '',
  rawFile: '',
  payStatus: '',
  payTime: '',
  priceSum: '',
  invoice: '',
  invoiceTag: '',
  invoiceType: '',
  invoiceTitle: '',
  invoiceTaxNum: '',
  invoicePhone: '',
  invoiceMail: '',
  invoiceAddr: '',
  examReportFile: [],
  orderId: ''
};

export default {
  name: 'OrderCreate',
  data: function() {
    const validateMobile = (rule, value, callback) => {
      if (String(value).length !== 11) {
        callback(new Error('请输入正确的电话号码！'));
        return;
      }
      callback();
    };
    return {
      dialogVisible: false,
      addForm: {
        mobile: '',
        name: ''
      },
      addRules: {
        name: [
          {required: true, message: '请输入医生名称', trigger: 'blur'},
        ],
        mobile: [
          {required: true, message: '请选输入电话', trigger: 'blur'},
          {type: 'number', message: '电话必须为数字'},
          {validator: validateMobile, trigger: 'blur'}
        ],
      },
      pageType: 'create',
      form: R.clone(form),
      reconData: [],

      refundShow: false, // 退款
      dialogRefund: false,
      refundForm: {},
    };
  },
  components: {
    FileUploader,
  },
  computed: {
    ...mapState('common', ['userInfo']),
    formList() {
      return formList;
    },
    rules() {
      const ru = {};
      R.pipe(
        R.filter(R.propEq('required', true)),
        R.forEach(({label, prop}) => {
          ru[prop] = [
            {required: true, message: `请输入${label}`, trigger: 'blur'},
          ];
        }),
      )(formList);
      return ru;
    },
    isDoc() {
      const {role} = this.userInfo;
      return isDoc(role);
    },
    isAgent() {
      const {role} = this.userInfo;
      return isAgent(role);
    },
    isCaptain() {
      const {role} = this.userInfo;
      return isCaptain(role);
    },
    isAdmin() {
      const {role} = this.userInfo;
      return isAdmin(role);
    },
    examTitle() {
      if (this.isDoc) {
        return '诊断报告及其他';
      }
      return '诊断报告';
    },
  },
  async mounted() {
    this.onCreated();
    this.loadReconData();
    if (!this.$route.params.id) {
      taskApi.fetchDraft({
        createBegin: Math.floor(new Date().getTime() / 1000) - 3600 * 24 * 7,
        createEnd: Math.floor(new Date().getTime() / 1000)
      }).then(res => {
        if (res.data && res.data.length > 0) {
          let orderTitles = res.data.map((item) => {
            return (item.patientName || '匿名') + '[' + (item.hospitalName || '') + ']';
          }).join(';');
          this.$confirm(orderTitles, '发现近期尚有' + res.count + '个订单待上传数据', {
            confirmButtonText: '查看',
            cancelButtonText: '取消',
            type: 'info',
          }).then(() => {
            this.$router.push({
              name: 'OrderUnsubmit',
            });
          });
        }
      });
    }
  },
  watch: {
    '$route'() {
      this.onCreated();
    },
  },
  // updated() {
  //   this.$refs.mockTable.doLayout();
  // },
  methods: {
    backToList() {
      this.keepCache = true;
      this.$router.back();
    },
    handleDoctorAdd() {
      this.dialogVisible = true;
    },
    isItemVisible(row, form) {
      const {visible} = row;
      if (R.is(Function, visible)) {
        form['isAdmin'] = this.isAdmin;
        form['isCaptain'] = this.isCaptain;
        return visible(form);
      }
      return true;
    },
    async onCreated() {
      this.resetForm();
      const {id} = this.$route.params;
      if (id) { // 查看详情模式
        this.pageType = 'unsubmit';
        const data = await taskApi.fetchById(id);
        if (data.code === 10000) {
          this.form = R.pick(R.keys(form), data.data);
          this.$refs.rawUpload.setFile({paths: [this.form.rawFile]});
          this.$refs.examUpload.setFile({paths: this.form.examReportFile});
        }
      }
      if (this.isDoc) {
        this.form.hospitalName = this.userInfo.hospitalName;
        this.form.departmentName = this.userInfo.departmentName;
      }
      if (this.isAdmin) {
        this.refundShow = true;
      }
    },
    resetForm() {
      this.pageType = 'create';
      this.form = R.clone(form);
      this.$refs.rawUpload.reset();
      this.$refs.examUpload.reset();
    },
    checkvalid() {
      return new Promise(resolve => {
        this.$refs.form.validate(async(valid) => {
          if (!this.form.rawFile) {
            tip.warning('请上传原始文件');
            return resolve(false);
          }
          if (valid) {
            return resolve(true);
          }
        });
      });
    },
    onRawFileSuccess({paths}) {
      this.form.rawFile = R.head(paths);
    },
    onExamFileSuccess({paths}) {
      this.form.examReportFile = paths;
    },
    toOrderAll() {
      if (this.isDoc || this.isAgent) {
        this.$router.push({
          name: 'OrderAll',
        });
      } else {
        this.$router.push({
          name: 'OrderAllInner',
        });
      }
    },
    async onSave() {
      const valid = await this.checkvalid();
      if (!valid) return;
      const data = await taskApi.create(this.form) || {};
      if (data.code === 10000) {
        tip.success('订单已保存到<待提交>，请尽快提交');
        this.resetForm();
        this.toOrderAll();
      }
    },
    async onSubmit() {
      const valid = await this.checkvalid();
      if (!valid) return;
      let id = this.$route.params.id;
      let selectedRecon = '';
      this.reconData.forEach(item => {
        // 先处理一级
        if (item.check) {
          selectedRecon += item.id + ',';
        }
        // 再处理二级
        item.children.forEach(child => {
          if (child.check) {
            if (child.inputText) {
              selectedRecon += child.id + ':' + child.inputText + ',';
            } else {
              selectedRecon += child.id + ',';
            }
          }
        });
      });
      if (selectedRecon.length <= 0) {
        tip.error('请选择重建类型！');
        return;
      }
      this.form['reconIds'] = selectedRecon;
      // console.log(this.form.examReportFile);
      if (!this.form.examReportFile || this.form.examReportFile.length <= 0) {
        let warning = '诊断报告暂未上传，继续操作可能导致系统输出三维器官模型同临床开具的影像诊断报告存在不一致的情形——尤其是对病灶的数量、位置、大小等。请确认是否在未提交影像报告的情况下开始重建。如点击确认，则表明您接受精诊科技提供的此次三维重建服务仅需以此患者合格、清晰的医学影像所见信息为准。';
        this.$confirm(warning, '风险警告', {
          confirmButtonText: '确定提交',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async() => {
          await this.doSubmit(id);
        });
      } else {
        await this.doSubmit(id);
      }
    },
    async doSubmit(id) {
      // 未提交状态，允许变更内容
      if (id) {
        // console.log({id, ...this.form});
        const data = await taskApi.create({id, ...this.form});
        if (data.code !== 10000) {
          return;
        }
      }
      if (this.pageType === 'create') {
        const data = await taskApi.create(this.form) || {};
        if (data.code === 60009) {
          const msg = '代理商(' + data.data.agentName + ')预付金余额不足，无法提交新订单，请联系精诊科技销售经理';
          this.$confirm(msg, '余额不足', {
            confirmButtonText: '确定',
            type: 'error',
          }).then(async() => {
          });
        }
        if (data.code !== 10000) {
          return;
        }
        id = data.data;
      }
      const subData = await taskApi.submit(id) || {};
      if (subData.code === 10000) {
        tip.success('订单已提交！');
        this.resetForm();
        this.toOrderAll();
      }
    },
    async onRawDelected({path}) {
      const {id} = this.$route.params;
      this.form.rawFile = null;
      if (this.pageType !== 'create') {
        taskApi.removeCreateFile({id, rawFile: path});
      }
    },
    async onExamReportDelected({path}) {
      const {id} = this.$route.params;
      this.form.examReportFile = [];
      if (this.pageType !== 'create') {
        taskApi.removeCreateFile({id, examReport: [path]});
      }
    },

    /**
     * 加载 重建类型 数据
     */
    async loadReconData() {
      const recon = await taskApi.reconData() || {};
      if (recon.code === 10000) {
        this.reconData = recon.data;
        for (let i = 0; i < this.reconData.length; i++) {
          if (this.reconData.children) {
            for (let j = 0; j < this.reconData.children.length; j++) {
              this.reconData[i].children[j].showInput = false;
              this.reconData[i].children[j].inputText = '';
            }
          }
        }
      }
    },
    changeCheck(id, level) {
      this.reconData.forEach(item => {
        if (item.id === id && level === 1) {
          item.children.forEach(child => {
            if (child.def) child.check = item.check;
          });
        }
        if (item.id === id && level === 2) {
          let allDefCount = 0;
          let checkDefCount = 0;
          item.children.forEach(child => {
            if (child.def) allDefCount += 1;
            if (child.def && child.check) checkDefCount += 1;
            item.check = allDefCount > 0 && allDefCount === checkDefCount;
            if (child.name === '模拟肝切除') {
              child.showInput = child.check;
              // child.inputText = '';
            }
          });
        }
      });
    },

    // 退款
    async onRefund() {
      if (this.form.payStatus !== 1) {
        this.$message.warning('订单状态非支付成功！');
        return;
      }
      if (this.form.priceSum <= 0) {
        this.$message.warning('订单需大于0');
        return;
      }
      if (!this.refundForm.verify) {
        return this.$message.warning('请输入安全密码');
      }
      if (!this.refundForm.remark) {
        return this.$message.warning('请输入退款原因');
      }
      if (!this.refundForm.optName) {
        return this.$message.warning('请输入操作人姓名');
      }
      this.refundForm.orderId = this.form.orderId;

      const res = await refundApi.refund(this.refundForm);
      if (res.code === 10000) {
        this.dialogRefund = false;
        this.$message.success('退款提交成功，处理结果请查看退款记录！');
      } else {
        this.$message.error(res.msg);
      }
    },
    // 合并订单
    async mergeOrder(srcTaskId) {
      this.$prompt('请输入安全密码', '安全密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputValidator: (val) => { if (!val) return '安全密码为必填'; },
        inputPattern: /^.+$/,
        inputErrorMessage: '安全密码为必填'
      }).then((result) => {
        let veifyCode = result.value;
        this.$prompt('删除订单请输入[删除],如需合并到其他订单,请输入订单号', '删除当前订单', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputValidator: (val) => { if (!val) return '订单号为必填'; },
          inputPattern: /^.+$/,
          inputErrorMessage: '输入要并入的订单号;如果要删除订单,请输入[删除]'
        }).then(async({value}) => {
          const data = await taskApi.mergeTask(srcTaskId, value, veifyCode);
          if (data.code === 10000) {
            tip.success('合并成功!');
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.mockData {
  /deep/ .el-table {
    border: 1px solid #9fa0a0;

    td {
      border: solid #9fa0a0;
      border-width: 0px 1px 1px 0px;
    }

    .el-table_1_column_2 .cell {
      padding-left: 0px;
      padding-right: 0px;

      .el-checkbox {
        margin: 10px;
        width: 200px;
      }

      .addition {
        float: left;
        margin: 10px;
        width: 200px;
      }
    }
  }

  .el-checkbox {
    margin: 10px;
    width: 200px;
  }
}

.back-button {
  position: fixed;
  top: 16px;
  left: 200px;
  background-color: rgba(221, 236, 255, 0.1);
  border: none;
  border-radius: 4px;
  width: 32px;
  height: 32px;
  padding: 0px;
  background-image: url('~@/assets/backto.png');
}
</style>



// WEBPACK FOOTER //
// src/view/OrderCreate/index.vue